if (!customElements.get('mbs-benefits')) {
  customElements.define('mbs-benefits', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const on = (el, type, fn) => el.addEventListener(type, fn, {signal:this.abort.signal});
      const list = this.querySelector('.mbsb__list');
      if (!list) return;
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      let paused = reduced.matches;
      let hovering = false;
      let touching = false;
      const stop = () => clearTimeout(this.timer);
      const schedule = () => {
        stop();
        const overflow = list.scrollWidth > list.clientWidth + 2;
        if (!overflow || paused || hovering || touching || this.contains(document.activeElement) || document.hidden || !this.visible) return;
        this.timer = setTimeout(() => {
          const items = [...list.children];
          const step = items[1] ? items[1].offsetLeft - items[0].offsetLeft : list.clientWidth;
          const max = list.scrollWidth - list.clientWidth;
          list.scrollTo({left:list.scrollLeft >= max - 2 ? 0 : Math.min(max, list.scrollLeft + step), behavior:reduced.matches ? 'instant' : 'smooth'});
          schedule();
        }, 4500);
      };
      on(this, 'pointerenter', e => {if(e.pointerType === 'mouse'){hovering = true; stop();}});
      on(this, 'pointerleave', () => {hovering = false; schedule();});
      on(this, 'pointerdown', () => {touching = true; stop();});
      on(window, 'pointerup', () => {touching = false; schedule();});
      on(window, 'pointercancel', () => {touching = false; schedule();});
      on(this, 'focusin', stop);
      on(this, 'focusout', () => queueMicrotask(schedule));
      on(list, 'scroll', schedule);
      on(document, 'visibilitychange', schedule);
      on(reduced, 'change', () => {paused = reduced.matches; schedule();});
      on(this, 'shopify:block:select', e => {
        paused = true;
        e.target.scrollIntoView({block:'nearest',inline:'nearest',behavior:'instant'});
        schedule();
      });
      this.resize = new ResizeObserver(schedule);
      this.resize.observe(list);
      this.intersection = new IntersectionObserver(entries => {this.visible = entries[0].isIntersecting; schedule();});
      this.intersection.observe(this);
      schedule();
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.abort?.abort();
      this.resize?.disconnect();
      this.intersection?.disconnect();
    }
  });
}
